import { GET_CUSTOM_ART_LIST, GET_CUSTOM_ART_LIST_FAIL, GET_CUSTOM_ART_LIST_SUCCESS, POST_CUSTOM_ART, POST_CUSTOM_ART_FAIL, POST_CUSTOM_ART_SUCCESS } from "./actionTypes";

const INIT_STATE = {
  error: "",
  loading: false,
  CustomArts:[]
}



const CustomArt = (state = INIT_STATE, action) => {
  switch (action.type) {
    case POST_CUSTOM_ART:
      return {
        ...state,
        loading: true,
      };
 
    case POST_CUSTOM_ART_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case POST_CUSTOM_ART_FAIL:
      return {
        ...state,
        loading: false,
        error:action.payload
      };
      
      case GET_CUSTOM_ART_LIST:
        return {
          ...state,
          loading: true,
        };
   
      case GET_CUSTOM_ART_LIST_SUCCESS:
        return {
          ...state,
          loading: false,
          CustomArts:action.payload || []
        };
  
      case GET_CUSTOM_ART_LIST_FAIL:
        return {
          ...state,
          loading: false,
          error:action.payload
        };

    default:
        return state;
    }


}



export default CustomArt;